import { render, staticRenderFns } from "./globalShare.vue?vue&type=template&id=d83c67ac"
import script from "./globalShare.vue?vue&type=script&lang=js"
export * from "./globalShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports